import type { ButtonHTMLAttributes } from 'react';
import styles from './Btn.module.css';

export type BtnVariant = 'default' | 'primary' | 'accent' | 'ghost';

interface BtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: BtnVariant;
}

const VARIANT_CLASS: Record<BtnVariant, string> = {
  default: '',
  primary: styles.primary,
  accent: styles.accent,
  ghost: styles.ghost,
};

export function Btn({ variant = 'default', className, children, ...rest }: BtnProps) {
  return (
    <button
      type="button"
      className={`${styles.btn} ${VARIANT_CLASS[variant]} ${className ?? ''}`}
      {...rest}
    >
      {children}
    </button>
  );
}
